import { Colors } from "@/enums/Colors";
import { CloseOutlined } from "@mui/icons-material";
import { Box, Button, Typography, styled } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CommonButton from "../utils/CommonButton";

interface Props {
  handleClose: () => void;
  handleConfirm: () => void;
  children?: React.ReactNode;
}

export const FirstTimeMultiUserChatMessage = ({ handleClose, handleConfirm, children }: Props) => {
  const { t } = useTranslation("chat");
  const onConfirm = () => {
    handleClose();
    handleConfirm();
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Container className="first-time-multi-user-chat-message">
        <Container className="title-container">
          <Typography fontWeight={600} fontSize={"1.125rem"}>
            {t("firstTimeMultiUserChat.title")}
          </Typography>
          <Button onClick={handleClose}>
            <CloseOutlined
              sx={{
                transform: "scale(1.3)",
                ":hover": { cursor: "pointer" },
              }}
            />
          </Button>
        </Container>
        <Typography color={Colors.LIGHT_GRAY_8A8E93} paddingBottom={"1rem"}>
          {t("firstTimeMultiUserChat.description")}
        </Typography>
        <Container className="button-container">
          <CommonButton sx={{ width: "50%", textTransform: "none" }} purpleBorderVariant onClick={onConfirm}>
            {t("firstTimeMultiUserChat.buttons.dontShowAgain")}
          </CommonButton>
          <CommonButton onClick={onConfirm} sx={{ width: "50%" }}>
            {t("firstTimeMultiUserChat.buttons.gotIt")}
          </CommonButton>
        </Container>
      </Container>
      <Container className="custom-triangle" />
      {children}
    </Box>
  );
};

const Container = styled(Box)(() => ({
  "&.first-time-multi-user-chat-message": {
    bottom: "150%",
    right: "-100%",
    position: "absolute",
    backgroundColor: "white",
    width: "21.125rem",
    boxShadow: "0px 9px 11px -2px rgba(0,0,0,0.2)",
    padding: "16px 24px",
    borderRadius: "14px",
  },
  "&.title-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "&.button-container": {
    display: "flex",
    columnGap: "0.5rem",
    "& button": { fontSize: "0.75rem" },
  },
  "&.custom-triangle": {
    position: "absolute",
    width: "0",
    height: "0",
    borderLeft: "0.625rem solid transparent",
    borderRight: "0.625rem solid transparent",
    borderTop: "0.625rem solid white",
    bottom: "120%",
    right: "18%",
  },
}));
